
<script setup lang="ts">

const { page, toc } = useContent()

page.value.tocBeginning = true

const isAPISidebar = page.value?.sidebar == 'API'

const tocTitle = computed(
    () => page.value?.toc_title
)

</script>

<template>
    <div class="flex flex-col">
        <template v-if="toc?.links?.length">
            <DocsTocLinksInContent v-if="isAPISidebar" :links="toc.links" class="text-lg" />
            <DocsTocLinksInContent v-else :links="toc.links" class="text-lg" />
        </template>
    </div>
</template>
